import React from "react";
import styles from "./ImageList.module.css";
import { handleImgError } from "../../Shared/ImageError";

function ImageList({ images, onImageClick, nextItem, previousItem }) {
  return (
    <div className={styles.ImageList}>
      {/* <div className={styles.next} onClick={nextItem}>
        &#9650;
      </div> */}
      {images &&
        images.length > 0 &&
        images.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => onImageClick(index)}
            onError={handleImgError}
          />
        ))}
      {/* <div className={styles.prev} onClick={previousItem}>
        &#9660;
      </div> */}
    </div>
  );
}

export default ImageList;
